module.exports = __webpack_public_path__ + "GiriNithinYogendra-e1d43e4f.webp";